import React, { useEffect, useRef, useState } from "react";
import "./Header.css";
import { FiCopy, FiCheck, FiBell, FiShare2, FiX } from "react-icons/fi";
import { MdLogout } from "react-icons/md";
import { FiMenu } from "react-icons/fi";
import { LuLink2 } from "react-icons/lu";
import { AiOutlineUser } from "react-icons/ai";
import { HiChevronDown } from "react-icons/hi";
import { setSidebarDisplay } from "./../../Redux/SideDisplaySlice";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import CopyFromtag from "../../Common/CopyFromtag";
import { setaccount } from "../../Redux/Accounts";
import { setDisConnectWallet } from "../../Redux/StatusState";
import { BasicInfo } from "../../Config/BasicInfo";

const Header = (props) => {
  const navigate = useNavigate();
  const [confirmLogout, setConfirmLogout] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const dispatch = useDispatch();
  const profileRef = useRef(null);

  const referralLinks =
    props?.link ||
    `${window.location.origin}/register?ref=${props?.username || ""}`;

  const isActive = props?.status !== 0;

  const displayName = props?.name || props?.username || "User";
  const initials = String(displayName)
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w.charAt(0).toUpperCase())
    .join("");

  function LogoutFunc() {
    localStorage.clear();
    dispatch(setaccount(null));
    dispatch(setDisConnectWallet(true));
    navigate("/");
  }

  function handleCopy(id) {
    CopyFromtag(id);
    setCopied(true);
    setTimeout(() => setCopied(false), 1400);
  }

  // Native share sheet where available (mobile browsers); otherwise copy.
  async function handleShare() {
    const payload = {
      title: `Join ${BasicInfo.projectName}`,
      text: `Join ${BasicInfo.projectName} using my referral link`,
      url: referralLinks,
    };
    if (navigator.share) {
      try {
        await navigator.share(payload);
        return;
      } catch (e) {
        if (e?.name === "AbortError") return; // user dismissed the sheet
      }
    }
    handleCopy("shareLink");
  }

  // Close the share popup with Escape and lock page scroll while open
  useEffect(() => {
    if (!shareOpen) return undefined;
    const onKey = (e) => e.key === "Escape" && setShareOpen(false);
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [shareOpen]);

  // Close profile dropdown on outside click
  useEffect(() => {
    function handleClickOutside(e) {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      {confirmLogout ? (
        <div className="otpSection" style={{ zIndex: "999" }}>
          <div className="otpContainer">
            <h1>Logout</h1>
            <p>Are you sure you want to log out?</p>
            <div>
              <button
                className="btnSecondary"
                onClick={() => setConfirmLogout(false)}
              >
                No
              </button>
              <button className="btnPrimary" onClick={() => LogoutFunc()}>
                Yes
              </button>
            </div>
          </div>
        </div>
      ) : null}

      <header className="navbar">
        <div
          className="alertMsg"
          id="CopiedMsg"
          style={{ top: "-130px", transition: "top 0.3s" }}
        >
          Link Copied!
        </div>

        {/* Left — brand (mobile) + greeting (desktop) */}
        <div className="navbarLeft">
          <button
            type="button"
            className="menuIcon"
            onClick={() => dispatch(setSidebarDisplay("block"))}
            aria-label="Open menu"
          >
            <FiMenu />
          </button>

          <Link to="/dashboard" className="navbarBrand">
            <img id="logoicon" src={BasicInfo.logo} alt={BasicInfo.projectName} />
          </Link>

          <div className="navbarGreeting">
            <span className="navbarGreetingHi">Welcome back</span>
            <span className="navbarGreetingName">{displayName}</span>
          </div>
        </div>

        {/* Center — referral link pill (desktop) */}
        <div className="navbarCenter">
          <div className="referralPill">
            <span className="referralPillIcon">
              <LuLink2 />
            </span>
            <div className="referralPillBody">
              <span className="referralPillLabel">Your referral link</span>
              <span className="referralPillLink" id="headerLink1">
                {referralLinks}
              </span>
            </div>
            <button
              type="button"
              className={`referralPillCopy ${copied ? "isCopied" : ""}`}
              onClick={() => handleCopy("headerLink1")}
              aria-label="Copy referral link"
            >
              {copied ? <FiCheck /> : <FiCopy />}
              <span>{copied ? "Copied" : "Copy"}</span>
            </button>
          </div>
        </div>

        {/* Right — status + profile + mobile menu */}
        <div className="navbarRight">
          <div className={`statusChip ${isActive ? "isOn" : "isOff"}`}>
            <span className="statusChipDot"></span>
            <span className="statusChipText">
              {isActive ? "Active" : "Inactive"}
            </span>
          </div>

          <button
            type="button"
            className="navIconBtn"
            onClick={() => navigate("/notification")}
            aria-label="Notifications"
            title="Notifications"
          >
            <FiBell />
            <span className="navIconDot" />
          </button>

          <div className="profileWrap" ref={profileRef}>
            <button
              type="button"
              className={`profileChip ${menuOpen ? "isOpen" : ""}`}
              onClick={() => setMenuOpen((v) => !v)}
            >
              <span className="profileAvatar">{initials || "U"}</span>
              <span className="profileMeta">
                <span className="profileName">{displayName}</span>
                {props?.username ? (
                  <span className="profileUser">@{props.username}</span>
                ) : null}
              </span>
              <span className="profileChevron">
                <HiChevronDown />
              </span>
            </button>

            {menuOpen ? (
              <div className="profileMenu">
                <div className="profileMenuHead">
                  <span className="profileAvatar lg">{initials || "U"}</span>
                  <div className="profileMenuHeadText">
                    <span className="profileName">{displayName}</span>
                    {props?.username ? (
                      <span className="profileUser">@{props.username}</span>
                    ) : null}
                    <span className={`profileMenuStatus ${isActive ? "isOn" : "isOff"}`}>
                      <span className="statusChipDot"></span>
                      {isActive ? "Active" : "Inactive"}
                    </span>
                  </div>
                </div>
                <button
                  type="button"
                  className="profileMenuItem"
                  onClick={() => {
                    setMenuOpen(false);
                    navigate("/profile");
                  }}
                >
                  <AiOutlineUser />
                  <span>My profile</span>
                </button>
                <button
                  type="button"
                  className="profileMenuItem"
                  onClick={() => {
                    setMenuOpen(false);
                    setShareOpen(true);
                  }}
                >
                  <FiShare2 />
                  <span>Share referral link</span>
                </button>
                <button
                  type="button"
                  className="profileMenuItem"
                  onClick={() => {
                    handleCopy("headerLink1");
                    setMenuOpen(false);
                  }}
                >
                  <FiCopy />
                  <span>Copy referral link</span>
                </button>
                <button
                  type="button"
                  className="profileMenuItem danger"
                  onClick={() => {
                    setMenuOpen(false);
                    setConfirmLogout(true);
                  }}
                >
                  <MdLogout />
                  <span>Logout</span>
                </button>
              </div>
            ) : null}
          </div>

        </div>
      </header>

      {/* Referral share popup */}
      {shareOpen ? (
        <div
          className="sharePopupOverlay"
          onClick={() => setShareOpen(false)}
          role="dialog"
          aria-modal="true"
          aria-labelledby="sharePopupTitle"
        >
          <div className="sharePopup" onClick={(e) => e.stopPropagation()}>
            <span className="sharePopupHandle" aria-hidden="true" />
            <button
              type="button"
              className="sharePopupClose"
              onClick={() => setShareOpen(false)}
              aria-label="Close"
            >
              <FiX />
            </button>

            <div className="sharePopupHead">
              <span className="sharePopupIcon">
                <LuLink2 />
              </span>
              <div>
                <h3 id="sharePopupTitle">Invite &amp; earn</h3>
                <p>
                  Share your personal link — anyone who registers through it
                  joins your team.
                </p>
              </div>
            </div>

            <div className="sharePopupLinkBox">
              <span className="sharePopupLabel">Your referral link</span>
              <span className="sharePopupLink" id="shareLink">
                {referralLinks}
              </span>
            </div>

            <div className="sharePopupActions">
              <button
                type="button"
                className={`sharePopupBtn ghost ${copied ? "isCopied" : ""}`}
                onClick={() => handleCopy("shareLink")}
              >
                {copied ? <FiCheck /> : <FiCopy />}
                <span>{copied ? "Copied" : "Copy link"}</span>
              </button>
              <button
                type="button"
                className="sharePopupBtn primary"
                onClick={handleShare}
              >
                <FiShare2 />
                <span>Share</span>
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Header;
